import { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  PageContainer,
  PageHeader,
  DataCard
} from '@/components/common'
import { FileUploadZone } from '@/components/upload/FileUploadZone'
import { UploadsList } from '@/components/upload/UploadsList'
import { DataPreview } from '@/components/upload/DataPreview'
import { useUploadStore } from '@/stores/uploadStore'
import { useAuth } from '@/contexts/AuthContext'
import { Upload } from '@/types'

export function UploadPage() {
  const navigate = useNavigate()
  const [selectedUpload, setSelectedUpload] = useState<Upload | null>(null)
  const { currentUser } = useAuth()

  const {
    uploads,
    loadUploads
  } = useUploadStore()

  useEffect(() => {
    if (currentUser) {
      loadUploads(currentUser)
    }
  }, [currentUser, loadUploads])

  const handleUploadComplete = useCallback((uploadId?: string) => {
    if (uploadId) {
      navigate(`/upload/workflow/${uploadId}`)
    }
  }, [navigate])

  const handleViewData = (upload: Upload) => {
    setSelectedUpload(upload)
  }

  return (
    <PageContainer>
      <PageHeader
        title="Uppladdning"
        subtitle="Ladda upp CSV eller Excel-filer med förardata"
      />

      {/* Upload zone */}
      <DataCard
        title="Ladda upp ny fil"
      >
        <FileUploadZone
          onUploadComplete={handleUploadComplete}
        />
      </DataCard>

      {/* Uploads list */}
      <UploadsList
        uploads={uploads}
        onViewData={handleViewData}
      />

      {/* Data preview modal */}
      {/* This should be reworked into something more userfriendly and reusable */}
      <DataPreview
        upload={selectedUpload}
        open={selectedUpload !== null}
        onClose={() => setSelectedUpload(null)}
      />
    </PageContainer>
  )
}